var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useReducer, } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { getUserSessionsRequest } from "../api/api";
import { SET_FULL_PAGE_LOADING, SET_USER_SESSIONS, } from "../constants";
import { reducer } from "../reducers/user-sessions-reducer";
import { LoadingContext } from "./LoadingContextProvider";
const initialState = {
    loading: true,
    sessionsSearchValue: "",
    userSessions: [],
};
const UserSessionsContext = createContext({
    state: initialState,
    usersSessionDispatch: () => { },
    loadUserSessions: () => __awaiter(void 0, void 0, void 0, function* () { }),
});
const UserSessionsContextProvider = ({ children, }) => {
    const [state, usersSessionDispatch] = useReducer(reducer, initialState);
    const { loadingDispatch } = useContext(LoadingContext);
    useEffect(() => {
        loadUserSessions();
    }, []);
    const loadUserSessions = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            loadingDispatch({ type: SET_FULL_PAGE_LOADING, payload: true });
            const response = yield getUserSessionsRequest();
            usersSessionDispatch({
                type: SET_USER_SESSIONS,
                payload: response.data,
            });
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to fetch user sessions", "quicktasker"));
        }
        finally {
            loadingDispatch({ type: SET_FULL_PAGE_LOADING, payload: false });
        }
    });
    return (_jsx(UserSessionsContext.Provider, { value: { state, usersSessionDispatch, loadUserSessions }, children: children }));
};
export { UserSessionsContext, UserSessionsContextProvider, };
